"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const SummaryCompositionTable_vue_1 = __importDefault(require("./SummaryCompositionTable.vue"));
const ControllerCompositionGisAreas_1 = __importDefault(require("../abstract/controllers/ControllerCompositionGisAreas"));
const Table_vue_1 = __importDefault(require("../components/Table.vue"));
const FooterTable_vue_1 = __importDefault(require("./FooterTable.vue"));
const ControllerGenerateDataSynthetic_1 = __importDefault(require("../abstract/controllers/ControllerGenerateDataSynthetic"));
const ViewZeroSearch_vue_1 = __importDefault(require("./ViewZeroSearch.vue"));
const ViewZeroAreasCount_vue_1 = __importDefault(require("./ViewZeroAreasCount.vue"));
const ControllerPostDataSynthetic_1 = __importDefault(require("../abstract/controllers/ControllerPostDataSynthetic"));
const ModelCompositorCategory_1 = __importDefault(require("../abstract/models/ModelCompositorCategory"));
let CompositionViewMain = class CompositionViewMain extends vue_property_decorator_1.Vue {
    constructor() {
        var _a;
        super(...arguments);
        this.textFilterSearch = '';
        this.areasChecked = [];
        this.controllerGisAreas = new ControllerCompositionGisAreas_1.default((_a = this.category) === null || _a === void 0 ? void 0 : _a.gis_areas);
        this.controllerSyntheticData = new ControllerGenerateDataSynthetic_1.default(this.gisAreasChecked());
        this.controllerPostDataSynthetic = new ControllerPostDataSynthetic_1.default(this.dataSyntheticBody);
    }
    resetTextFilter() {
        this.textFilterSearch = '';
    }
    get loadingSyntheticRate() {
        return this.controllerPostDataSynthetic.isLoading;
    }
    emitLoadingRate() {
        if (this.loadingSyntheticRate)
            this.$emit('createProject');
    }
    createSyntheticRate(areaSyntheticName) {
        const dataBody = this.dataSyntheticBody;
        dataBody.area_name = areaSyntheticName;
        this.controllerPostDataSynthetic = new ControllerPostDataSynthetic_1.default(dataBody);
        this.controllerPostDataSynthetic.createSyntheticRate();
        this.$emit('createProject');
    }
    get dataSyntheticBody() {
        const dataBody = {
            gis_area_ids: [],
            proposal_id: 0,
            area_name: '',
            crop_id: 0,
            acreage: {
                value: 0,
                unit: '',
            },
            category: '',
            score: 0,
            due_date: '',
        };
        dataBody.gis_area_ids = this.areasChecked;
        dataBody.proposal_id = this.proposalId;
        dataBody.crop_id = this.dataSynthetic.crop.id;
        dataBody.acreage.unit = this.dataSynthetic.agreage.unit;
        dataBody.acreage.value = this.dataSynthetic.agreage.value;
        dataBody.category = this.category.category;
        dataBody.score = this.dataSynthetic.score;
        dataBody.due_date = this.dataSynthetic.valid_date;
        return dataBody;
    }
    get dataSynthetic() {
        return this.controllerSyntheticData.getDataSynthetic;
    }
    get isDeployTable() {
        var _a;
        if (this.gisAreasFilter &&
            this.gisAreasFilter.length > 0 &&
            ((_a = this.category) === null || _a === void 0 ? void 0 : _a.count) > 0) {
            return true;
        }
        return false;
    }
    get isDeployViewZeroCount() {
        var _a;
        if (((_a = this.category) === null || _a === void 0 ? void 0 : _a.count) < 1)
            return true;
        return false;
    }
    get isDeployViewSearch() {
        var _a;
        if (this.gisAreasFilter &&
            this.gisAreasFilter.length < 1 &&
            ((_a = this.category) === null || _a === void 0 ? void 0 : _a.count) > 0) {
            return true;
        }
        return false;
    }
    get gisAreasFilter() {
        const category = new ModelCompositorCategory_1.default(this.category, false);
        if (this.currentCrop > 0) {
            category.filterGisAreasByCropId(this.currentCrop);
        }
        return category.filterGisAreasByParam(this.textFilterSearch);
    }
    get gisAreasFilterByCrop() {
        const category = new ModelCompositorCategory_1.default(this.category, false);
        return category.filterGisAreasByCropId(this.currentCrop);
    }
    gisAreasChecked() {
        var _a, _b;
        if ((_a = this.category) === null || _a === void 0 ? void 0 : _a.gis_areas) {
            const objetosFiltrados = (_b = this.category) === null || _b === void 0 ? void 0 : _b.gis_areas.filter((objeto) => this.areasChecked.includes(objeto.gis_area_id));
            return objetosFiltrados;
        }
        else {
            return [];
        }
    }
    composeDataSynthetic() {
        this.controllerSyntheticData = new ControllerGenerateDataSynthetic_1.default(this.gisAreasChecked());
        this.controllerSyntheticData.composeDataSynthetic();
    }
    textFilter(text) {
        this.textFilterSearch = text;
    }
    giveAreasChecked(areasIds) {
        this.areasChecked = areasIds;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: ModelCompositorCategory_1.default, default: {} })
], CompositionViewMain.prototype, "category", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], CompositionViewMain.prototype, "proposalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], CompositionViewMain.prototype, "currentCrop", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('category')
], CompositionViewMain.prototype, "resetTextFilter", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('loadingSyntheticRate')
], CompositionViewMain.prototype, "emitLoadingRate", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('areasChecked')
], CompositionViewMain.prototype, "composeDataSynthetic", null);
CompositionViewMain = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            SummaryCompositionTable: SummaryCompositionTable_vue_1.default,
            Table: Table_vue_1.default,
            FooterTable: FooterTable_vue_1.default,
            ViewZeroSearch: ViewZeroSearch_vue_1.default,
            ViewZeroAreasCount: ViewZeroAreasCount_vue_1.default,
        },
    })
], CompositionViewMain);
exports.default = CompositionViewMain;
